<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card>
                <v-list two-line>
                    <template v-for="(item, index) in items">
                        <v-list-tile
                                :key="item.title"
                                avatar
                                ripple
                                @click="startAssessment(item.assessmentId)"
                        >
                            <v-list-tile-avatar>
                                <v-icon>assignment</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                <v-list-tile-sub-title class="text--primary">{{ item.headline }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                                v-if="index + 1 < items.length"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        data() {
            return {
                items: []
            }
        },

        methods: {
            startAssessment(assessmentId) {
                this.$router.push({
                        name: 'test',
                        params: {
                            id: assessmentId
                        }
                    });
            },
        },

        mounted() {
            this.$store.dispatch('searchAssessments')
                .then((aList) => {
                if (!aList || !aList.length) {
                    return Promise.reject('Tests were not found');
                }

                this.items = aList;
            });
        }
    }
</script>
